import React, { useEffect, useRef } from 'react'
import Select from 'react-select'

import 'react-select/dist/react-select.css'

const SELECTS = require('../Datas/Selects')

const AgendaFormFilterPublics = ({OnChangeFilterPublic, AgendaFilterActivePublic}) => {
	const selectRef = useRef(null)
	// Validation des props et gestion des erreurs
	if (typeof OnChangeFilterPublic !== 'function') {
		return (
			<div role="region" aria-label="Filtre de publics d'événements" className="agenda-form-filter-publics-error">
				<div role="alert" aria-live="polite">
					<p>Erreur : fonction de changement de filtre manquante ou invalide</p>
				</div>
			</div>
		)
	}

	// Validation des données de sélection
	if (!SELECTS || !SELECTS['publics'] || !Array.isArray(SELECTS['publics'])) {
		return (
			<div role="region" aria-label="Filtre de publics d'événements" className="agenda-form-filter-publics-error">
				<div role="alert" aria-live="polite">
					<p>Erreur : données de publics manquantes ou invalides</p>
				</div>
			</div>
		)
	}

	// Construction de l'aria-label pour le composant Select
	const selectLabel = "Sélectionner le public cible"
	const selectDescription = "Filtre pour sélectionner le public cible des événements à afficher dans l'agenda"

	// Effet pour ajouter le rôle listbox au conteneur des options
	useEffect(() => {
		const updateSelectAccessibility = () => {
			if (typeof window === 'undefined' || !selectRef.current) return

			// Trouver le conteneur du menu des options de react-select
			// react-select crée une structure avec .Select-menu-outer contenant .Select-menu
			// Le menu peut être dans le conteneur ou dans document.body (portail)
			const menuContainer = document.querySelector('#react-select-3--value .Select-value')

			if (menuContainer) {
				// Ajouter le rôle listbox au conteneur des options
				menuContainer.setAttribute('role', 'listbox')
				menuContainer.setAttribute('id', 'agenda-filters-publics-listbox')
				menuContainer.setAttribute('aria-label', 'Tous les publics')
				
				// S'assurer que les options ont le bon rôle
				const options = menuContainer.querySelectorAll('.Select-option')
				options.forEach((option, index) => {
					if (!option.hasAttribute('role')) {
						option.setAttribute('role', 'option')
					}
					if (!option.hasAttribute('id')) {
						option.setAttribute('id', `agenda-filters-publics-option-${index}`)
					}
				})
			}

			// Trouver le contrôle principal (combobox)
			const control = selectRef.current.querySelector('.Select-control')
			if (control) {
				const input = control.querySelector('input')
				if (input) {
					// Ajouter aria-owns pour lier le combobox au listbox
					input.setAttribute('aria-owns', 'agenda-filters-publics-listbox')
					input.setAttribute('aria-haspopup', 'listbox')
					if (!input.hasAttribute('role')) {
						input.setAttribute('role', 'combobox')
					}
				}
			}
		}

		// Mettre à jour immédiatement
		updateSelectAccessibility()

		// Observer les changements du DOM pour mettre à jour quand le menu s'ouvre
		// Observer à la fois le conteneur et document.body (au cas où le menu est rendu en portail)
		const observer = new MutationObserver(() => {
			setTimeout(updateSelectAccessibility, 50)
		})
		
		if (selectRef.current) {
			observer.observe(selectRef.current, {
				childList: true,
				subtree: true,
				attributes: true,
				attributeFilter: ['class']
			})
		}

		// Observer aussi document.body au cas où le menu est rendu en portail
		const bodyObserver = new MutationObserver(() => {
			setTimeout(updateSelectAccessibility, 50)
		})
		
		bodyObserver.observe(document.body, {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ['class', 'role']
		})

		// Écouter les événements de clic et de focus pour mettre à jour quand le menu s'ouvre
		const handleInteraction = () => {
			setTimeout(updateSelectAccessibility, 100)
		}

		if (selectRef.current) {
			selectRef.current.addEventListener('click', handleInteraction)
			selectRef.current.addEventListener('focus', handleInteraction, true)
		}

		return () => {
			observer.disconnect()
			bodyObserver.disconnect()
			if (selectRef.current) {
				selectRef.current.removeEventListener('click', handleInteraction)
				selectRef.current.removeEventListener('focus', handleInteraction, true)
			}
		}
	}, [AgendaFilterActivePublic])

	return (
		<div role="group" aria-label="Filtre de publics d'événements" className="agenda-form-filter-publics-container">
			<label htmlFor="agenda-filters-publics" className="agenda-form-filter-publics-label visually-hidden">
				{selectLabel}
			</label>
			
			<div ref={selectRef}>
				<Select 
					id="agenda-filters-publics"
					className="generic-filters-select agenda-filters-select agenda-filters-select-publics" 
					name="agenda-filters-publics" 
					placeholder="Tous les publics" 
					options={SELECTS['publics']} 
					onChange={OnChangeFilterPublic} 
					value={AgendaFilterActivePublic}
					simpleValue
					clearable={false}
					searchable={false}
					aria-label={selectLabel}
					aria-describedby="agenda-form-filter-publics-description"
				/>
			</div>
			
			{/* Description accessible pour les lecteurs d'écran */}
			<div 
				id="agenda-form-filter-publics-description" 
				className="visually-hidden" 
				aria-live="polite"
			>
				{selectDescription}
			</div>

			{/* Message de statut pour les lecteurs d'écran */}
			<div 
				className="visually-hidden" 
				aria-live="polite" 
				aria-label="Statut du filtre de publics"
			>
				Filtre de publics chargé avec succès
			</div>
		</div>
	)
}

export default AgendaFormFilterPublics
